import {
  CreateAnnouncementMutationVariables,
  UpdateAnnouncementMutationVariables,
  _Boolean,
} from '@/API';
import {
  CreateAnnouncementMutation,
  UpdateAnnouncementMutation,
  createAnnouncementWithConnection as createAnnouncementMutation,
  updateAnnouncementWithConnection as updateAnnouncementMutation,
} from '@/appsync/graphql/announcement';
import { UpdateUserAnnouncementInput } from '@/appsync/graphql/userAnnouncement';
import { updateUserAnnouncement } from '@/appsync/graphql/userAnnouncement';

import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { Announcement, AnnouncementForDisplay } from '@/types/type';
import { getStartDateTime, getEndDateTime } from '@/utils/AnnouncementUtils';
import { getSHA3of } from '@/utils/CommonUtils';

const inputValueToMutationVariables = (
  param: Announcement | AnnouncementForDisplay
) => ({
  title: param.title,
  content: param.content,
  priorityTag: param.priorityTag,
  linkToProductMenu: '',
  isPublic: param.isPublic ? _Boolean._true : _Boolean._false,
  displayStartDate: getStartDateTime(param.displayStartDate),
  displayEndDate:
    param.displayEndDate === null ? 0 : getEndDateTime(param.displayEndDate),
});

export const createAnnouncement = async (
  param: Announcement | AnnouncementForDisplay,
  tenant: string,
  landscape: string
): Promise<void> => {
  const variables: CreateAnnouncementMutationVariables = {
    input: {
      ...inputValueToMutationVariables(param),
      tenant,
      landscape,
      tenantLandscape: getSHA3of(`${tenant}#${landscape}`),
    },
  };

  await graphqlQuery<
    CreateAnnouncementMutation,
    CreateAnnouncementMutationVariables
  >(createAnnouncementMutation, variables);
};

export const updateIsReadStatus = async (
  tenant: string,
  landscape: string,
  loginName: string,
  announcementId: string,
  displayStartDate: number
) => {
  const input: UpdateUserAnnouncementInput = {
    tenant,
    landscape,
    loginName,
    announcementId,
    displayStartDate,
    isRead: _Boolean._true,
  };
  await graphqlQuery(updateUserAnnouncement, { input });
};

export const updateAnnouncement = async (
  param: AnnouncementForDisplay
): Promise<void> => {
  const variables: UpdateAnnouncementMutationVariables = {
    input: {
      ...inputValueToMutationVariables(param),
      id: param.id,
      tenant: param.tenant,
      landscape: param.landscape,
    },
  };

  await graphqlQuery<
    UpdateAnnouncementMutation,
    UpdateAnnouncementMutationVariables
  >(updateAnnouncementMutation, variables);
};
